import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AnimatedCol from "../../../../components/AnimatedCol.jsx";
import Headline from "../../../../components/UI/Headline.jsx";
import MainArea from "../../../../components/UI/MainArea.jsx";
import DesignLoad from "../Innere/DesignLoad.jsx";
import DrillBitDiameter from "../Innere/DrillBitDiameter.jsx";
import LoadType from "../Innere/LoadType.jsx";
import SelectedLoadCarryingElement from "../Innere/SelectedLoadCarryingElement.jsx";
import OuterTable from "./OuterTable.jsx";
import ExtensionIntoFoundation from "./ExtensionIntoFoundation.jsx";
import InclinedLengthSum from "./InclinedLengthSum.jsx";
import InfoBox from "./InfoBox.jsx";
import PileInclination from "./PileInclination.jsx";
import TotalLength from "./TotalLength.jsx";

export default function Outer() {
  const { t } = useTranslation("translation");

  return (
    <MainArea>
      <Headline isPrimary text={t("aashto.ausser.Outer Load Carrying Capacity")} />
      <Row>
        <div className="mt-5">
          <AnimatedCol>
            <InfoBox />
          </AnimatedCol>
        </div>

        <div className="mt-5">
          <Headline text={t("aashto.ausser.Outer Load Carrying Capacity")} />

          <AnimatedCol>
            <DesignLoad readOnly />
          </AnimatedCol>

          <AnimatedCol>
            <SelectedLoadCarryingElement readOnly />
          </AnimatedCol>

          <AnimatedCol>
            <LoadType readOnly />
          </AnimatedCol>

          <AnimatedCol>
            <DrillBitDiameter readonly />
          </AnimatedCol>

          <AnimatedCol>
            <PileInclination />
          </AnimatedCol>
        </div>
      </Row>

      <div className="mt-5">
        <Row>
          <Headline text={t("aashto.ausser.Soil Layers")} />
          <Col>
            <AnimatedCol>
              <OuterTable />
            </AnimatedCol>
          </Col>
        </Row>
      </div>

      <div className="mt-5">
        <Row>
          <Headline text={t("aashto.ausser.Determining the total length")} />
          <AnimatedCol>
            <InclinedLengthSum />
          </AnimatedCol>

          <AnimatedCol>
            <ExtensionIntoFoundation />
          </AnimatedCol>

          <AnimatedCol>
            <TotalLength />
          </AnimatedCol>
        </Row>
      </div>
    </MainArea>
  );
}
